(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports'], factory);
  else if (typeof exports === 'object')
    factory(module.exports);
  else
    root['openrndr-js-tree'] = factory(typeof this['openrndr-js-tree'] === 'undefined' ? {} : this['openrndr-js-tree']);
}(this, function (_) {
  'use strict';
  Default.prototype = Object.create(Random.prototype);
  Default.prototype.constructor = Default;
  XorWowRandom.prototype = Object.create(Random.prototype);
  XorWowRandom.prototype.constructor = XorWowRandom;
  IntRange.prototype = Object.create(IntProgression.prototype);
  IntRange.prototype.constructor = IntRange;
  Long.prototype = Object.create(Number_0.prototype);
  Long.prototype.constructor = Long;
  Exception.prototype = Object.create(Error.prototype);
  Exception.prototype.constructor = Exception;
  RuntimeException.prototype = Object.create(Exception.prototype);
  RuntimeException.prototype.constructor = RuntimeException;
  IllegalArgumentException.prototype = Object.create(RuntimeException.prototype);
  IllegalArgumentException.prototype.constructor = IllegalArgumentException;
  ClassCastException.prototype = Object.create(RuntimeException.prototype);
  ClassCastException.prototype.constructor = ClassCastException;
  UninitializedPropertyAccessException.prototype = Object.create(RuntimeException.prototype);
  UninitializedPropertyAccessException.prototype.constructor = UninitializedPropertyAccessException;
  function until(_this_, to) {
    if (to <= IntCompanionObject_getInstance()._MIN_VALUE)
      return Companion_getInstance_0()._EMPTY;
    return numberRangeToNumber(_this_, to - 1 | 0);
  }
  function Default() {
    Default_instance = this;
    Random.call(this);
    this._defaultRandom = defaultPlatformRandom();
  }
  Default.prototype.nextBits_1 = function (bitCount) {
    return this._defaultRandom.nextBits_1(bitCount);
  };
  Default.prototype.nextInt_3 = function () {
    return this._defaultRandom.nextInt_3();
  };
  Default.prototype.nextInt_4 = function (from, until_0) {
    return this._defaultRandom.nextInt_4(from, until_0);
  };
  Default.prototype.nextDouble_3 = function () {
    return this._defaultRandom.nextDouble_3();
  };
  Default.prototype.nextDouble_4 = function (from, until_0) {
    return this._defaultRandom.nextDouble_4(from, until_0);
  };
  Default.$metadata$ = {
    simpleName: 'Default',
    kind: 'object',
    interfaces: []
  };
  var Default_instance;
  function Default_getInstance() {
    if (Default_instance == null)
      new Default();
    return Default_instance;
  }
  function Random() {
    Default_getInstance();
  }
  Random.prototype.nextInt_3 = function () {
    return this.nextBits_1(32);
  };
  Random.prototype.nextInt_4 = function (from, until_0) {
    checkRangeBounds(from, until_0);
    var n = until_0 - from | 0;
    if (n > 0 ? true : n === IntCompanionObject_getInstance()._MIN_VALUE) {
      var tmp;
      if ((n & (-n | 0)) === n) {
        var bitCount = fastLog2(n);
        tmp = this.nextBits_1(bitCount);
      } else {
        var v;
        do {
          var bits = this.nextInt_3() >>> 1;
          v = bits % n;
        }
         while (((bits - v | 0) + (n - 1 | 0) | 0) < 0);
        tmp = v;
      }
      var rnd = tmp;
      return from + rnd | 0;
    } else {
      while (true) {
        var rnd_0 = this.nextInt_3();
        if (from <= rnd_0 ? rnd_0 < until_0 : false)
          return rnd_0;
      }
    }
  };
  Random.prototype.nextDouble_3 = function () {
    return doubleFromParts(this.nextBits_1(26), this.nextBits_1(27));
  };
  Random.prototype.nextDouble_4 = function (from, until_0) {
    checkRangeBounds_0(from, until_0);
    var size = until_0 - from;
    var tmp;
    if ((isInfinite(size) ? isFinite(from) : false) ? isFinite(until_0) : false) {
      var r1 = this.nextDouble_3() * (until_0 / 2 - from / 2);
      tmp = from + r1 + r1;
    } else {
      tmp = from + this.nextDouble_3() * size;
    }
    var r = tmp;
    return r >= until_0 ? nextDown(until_0) : r;
  };
  Random.$metadata$ = {
    simpleName: 'Random',
    kind: 'class',
    interfaces: []
  };
  function Random_0(seed) {
    return XorWowRandom_init_$Create$(seed, seed >> 31);
  }
  function nextInt(_this_, range) {
    var tmp;
    if (range.isEmpty()) {
      throw IllegalArgumentException_init_$Create$('' + 'Cannot get random in empty range: ' + range);
    } else if (range._get_last__0() < IntCompanionObject_getInstance()._MAX_VALUE) {
      tmp = _this_.nextInt_4(range._get_first__0(), range._get_last__0() + 1 | 0);
    } else if (range._get_first__0() > IntCompanionObject_getInstance()._MIN_VALUE) {
      tmp = _this_.nextInt_4(range._get_first__0() - 1 | 0, range._get_last__0()) + 1 | 0;
    } else {
      tmp = _this_.nextInt_3();
    }
    return tmp;
  }
  function checkRangeBounds(from, until_0) {
    var tmp0_require_0 = until_0 > from;
    var tmp;
    if (!tmp0_require_0) {
      var message_2 = boundsErrorMessage(from, until_0);
      throw IllegalArgumentException_init_$Create$(toString(message_2));
    }return tmp;
  }
  function fastLog2(value) {
    return 31 - Math.clz32(value) | 0;
  }
  function checkRangeBounds_0(from, until_0) {
    var tmp0_require_0 = until_0 > from;
    var tmp;
    if (!tmp0_require_0) {
      var message_2 = boundsErrorMessage(from, until_0);
      throw IllegalArgumentException_init_$Create$(toString(message_2));
    }return tmp;
  }
  function boundsErrorMessage(from, until_0) {
    return '' + 'Random range is empty: [' + from + ', ' + until_0 + ').';
  }
  function takeUpperBits(_this_, bitCount) {
    return _this_ >>> (32 - bitCount | 0) & (-bitCount | 0) >> 31;
  }
  function XorWowRandom_init_$Init$(seed1, seed2, $this) {
    XorWowRandom.call($this, seed1, seed2, 0, 0, ~seed1, seed1 << 10 ^ seed2 >>> 4);
    return $this;
  }
  function XorWowRandom_init_$Create$(seed1, seed2) {
    return XorWowRandom_init_$Init$(seed1, seed2, Object.create(XorWowRandom.prototype));
  }
  function XorWowRandom(x, y, z, w, v, addend) {
    Random.call(this);
    this._x = x;
    this._y = y;
    this._z = z;
    this._w = w;
    this._v = v;
    this._addend = addend;
    var tmp0_require_0 = !((this._x | this._y | this._z | this._w | this._v) === 0);
    if (!tmp0_require_0) {
      var message_2 = 'Initial state must have at least one non-zero element.';
      throw IllegalArgumentException_init_$Create$(toString(message_2));
    }var tmp1_repeat_0 = 64;
    var inductionVariable = 0;
    if (inductionVariable < tmp1_repeat_0)
      do {
        var index_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.nextInt_3();
        Unit_getInstance();
      }
       while (inductionVariable < tmp1_repeat_0);
  }
  XorWowRandom.prototype.nextInt_3 = function () {
    var t = this._x;
    t = t ^ t >>> 2;
    this._x = this._y;
    this._y = this._z;
    this._z = this._w;
    var v0 = this._v;
    this._w = v0;
    t = t ^ t << 1 ^ v0 ^ v0 << 4;
    this._v = t;
    var tmp0_this = this;
    tmp0_this._addend = tmp0_this._addend + 362437 | 0;
    return t + this._addend | 0;
  };
  XorWowRandom.prototype.nextBits_1 = function (bitCount) {
    return takeUpperBits(this.nextInt_3(), bitCount);
  };
  XorWowRandom.$metadata$ = {
    simpleName: 'XorWowRandom',
    kind: 'class',
    interfaces: []
  };
  function Annotation() {
  }
  Annotation.$metadata$ = {
    simpleName: 'Annotation',
    kind: 'interface',
    interfaces: []
  };
  function Comparable() {
  }
  Comparable.$metadata$ = {
    simpleName: 'Comparable',
    kind: 'interface',
    interfaces: []
  };
  function Number_0() {
  }
  Number_0.$metadata$ = {
    simpleName: 'Number',
    kind: 'class',
    interfaces: []
  };
  function Companion_0() {
    Companion_instance = this;
  }
  Companion_0.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion_0();
    return Companion_instance;
  }
  function IntProgression(start, endInclusive, step) {
    Companion_getInstance();
    if (step === 0)
      throw IllegalArgumentException_init_$Create$('Step must be non-zero.');
    if (step === IntCompanionObject_getInstance()._MIN_VALUE)
      throw IllegalArgumentException_init_$Create$('Step must be greater than Int.MIN_VALUE to avoid overflow on negation.');
    this._first = start;
    this._last = getProgressionLastElement(start, endInclusive, step);
    this._step = step;
  }
  IntProgression.prototype._get_first__0 = function () {
    return this._first;
  };
  IntProgression.prototype._get_last__0 = function () {
    return this._last;
  };
  IntProgression.prototype.toString = function () {
    return this._step > 0 ? '' + this._first + '..' + this._last + ' step ' + this._step : '' + this._first + ' downTo ' + this._last + ' step ' + (-this._step | 0);
  };
  IntProgression.$metadata$ = {
    simpleName: 'IntProgression',
    kind: 'class',
    interfaces: [Iterable]
  };
  function ClosedRange() {
  }
  ClosedRange.$metadata$ = {
    simpleName: 'ClosedRange',
    kind: 'interface',
    interfaces: []
  };
  function Companion_1() {
    Companion_instance_0 = this;
    this._EMPTY = new IntRange(1, 0);
  }
  Companion_1.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_1();
    return Companion_instance_0;
  }
  function IntRange(start, endInclusive) {
    Companion_getInstance_0();
    IntProgression.call(this, start, endInclusive, 1);
  }
  IntRange.prototype.isEmpty = function () {
    return this._get_first__0() > this._get_last__0();
  };
  IntRange.prototype.toString = function () {
    return '' + this._get_first__0() + '..' + this._get_last__0();
  };
  IntRange.$metadata$ = {
    simpleName: 'IntRange',
    kind: 'class',
    interfaces: [ClosedRange]
  };
  function Unit() {
    Unit_instance = this;
  }
  Unit.prototype.toString = function () {
    return 'kotlin.Unit';
  };
  Unit.$metadata$ = {
    simpleName: 'Unit',
    kind: 'object',
    interfaces: []
  };
  var Unit_instance;
  function Unit_getInstance() {
    if (Unit_instance == null)
      new Unit();
    return Unit_instance;
  }
  function getProgressionLastElement(start, end, step) {
    var tmp;
    if (step > 0) {
      tmp = start >= end ? end : end - differenceModulo(end, start, step) | 0;
    } else if (step < 0) {
      tmp = start <= end ? end : end + differenceModulo(start, end, -step | 0) | 0;
    } else {
      throw IllegalArgumentException_init_$Create$('Step is zero.');
    }
    return tmp;
  }
  function differenceModulo(a, b, c) {
    return mod(mod(a, c) - mod(b, c) | 0, c);
  }
  function mod(a, b) {
    var mod_0 = a % b;
    return mod_0 >= 0 ? mod_0 : mod_0 + b | 0;
  }
  function IntCompanionObject_0() {
    IntCompanionObject_instance = this;
    this._MIN_VALUE = -2147483648;
    this._MAX_VALUE = 2147483647;
    this._SIZE_BYTES = 4;
    this._SIZE_BITS = 32;
  }
  IntCompanionObject_0.prototype._get_MIN_VALUE__0 = function () {
    return this._MIN_VALUE;
  };
  IntCompanionObject_0.prototype._get_MAX_VALUE__0 = function () {
    return this._MAX_VALUE;
  };
  IntCompanionObject_0.prototype._get_SIZE_BYTES__0 = function () {
    return this._SIZE_BYTES;
  };
  IntCompanionObject_0.prototype._get_SIZE_BITS__0 = function () {
    return this._SIZE_BITS;
  };
  IntCompanionObject_0.$metadata$ = {
    simpleName: 'IntCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(IntCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_MIN_VALUE__0
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_MAX_VALUE__0
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_SIZE_BYTES__0
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_SIZE_BITS__0
  });
  var IntCompanionObject_instance;
  function IntCompanionObject_getInstance() {
    if (IntCompanionObject_instance == null)
      new IntCompanionObject_0();
    return IntCompanionObject_instance;
  }
  function DoubleCompanionObject_0() {
    DoubleCompanionObject_instance = this;
    this._MIN_VALUE_0 = 4.9E-324;
    this._MAX_VALUE_0 = 1.7976931348623157E308;
    this._POSITIVE_INFINITY = Infinity;
    this._NEGATIVE_INFINITY = -Infinity;
    this._NaN = NaN;
    this._SIZE_BYTES_0 = 8;
    this._SIZE_BITS_0 = 64;
  }
  DoubleCompanionObject_0.prototype._get_MIN_VALUE__0 = function () {
    return this._MIN_VALUE_0;
  };
  DoubleCompanionObject_0.prototype._get_MAX_VALUE__0 = function () {
    return this._MAX_VALUE_0;
  };
  DoubleCompanionObject_0.prototype._get_POSITIVE_INFINITY_ = function () {
    return this._POSITIVE_INFINITY;
  };
  DoubleCompanionObject_0.prototype._get_NEGATIVE_INFINITY_ = function () {
    return this._NEGATIVE_INFINITY;
  };
  DoubleCompanionObject_0.prototype._get_NaN_ = function () {
    return this._NaN;
  };
  DoubleCompanionObject_0.prototype._get_SIZE_BYTES__0 = function () {
    return this._SIZE_BYTES_0;
  };
  DoubleCompanionObject_0.prototype._get_SIZE_BITS__0 = function () {
    return this._SIZE_BITS_0;
  };
  DoubleCompanionObject_0.$metadata$ = {
    simpleName: 'DoubleCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_MIN_VALUE__0
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_MAX_VALUE__0
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'POSITIVE_INFINITY', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_POSITIVE_INFINITY_
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'NEGATIVE_INFINITY', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_NEGATIVE_INFINITY_
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'NaN', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_NaN_
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_SIZE_BYTES__0
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_SIZE_BITS__0
  });
  var DoubleCompanionObject_instance;
  function DoubleCompanionObject_getInstance() {
    if (DoubleCompanionObject_instance == null)
      new DoubleCompanionObject_0();
    return DoubleCompanionObject_instance;
  }
  function _get_ulp_(_this_) {
    return _this_ < 0.0 ? _get_ulp_(-_this_) : (isNaN_0(_this_) ? true : _this_ === Infinity) ? _this_ : _this_ === 1.7976931348623157E308 ? _this_ - nextDown(_this_) : nextUp(_this_) - _this_;
  }
  function nextDown(_this_) {
    var tmp;
    if (isNaN_0(_this_) ? true : _this_ === -Infinity) {
      tmp = _this_;
    } else if (_this_ === 0.0) {
      tmp = -4.9E-324;
    } else {
      var tmp2_fromBits_0 = DoubleCompanionObject_getInstance();
      var tmp0_plus_0 = toRawBits(_this_);
      var tmp1_plus_0 = _this_ > 0.0 ? -1 : 1;
      var tmp3_fromBits_0 = tmp0_plus_0.plus_28(toLong(tmp1_plus_0));
      tmp = doubleFromBits(tmp3_fromBits_0);
    }
    return tmp;
  }
  function nextUp(_this_) {
    var tmp;
    if (isNaN_0(_this_) ? true : _this_ === Infinity) {
      tmp = _this_;
    } else if (_this_ === 0.0) {
      tmp = 4.9E-324;
    } else {
      var tmp2_fromBits_0 = DoubleCompanionObject_getInstance();
      var tmp0_plus_0 = toRawBits(_this_);
      var tmp1_plus_0 = _this_ > 0.0 ? 1 : -1;
      var tmp3_fromBits_0 = tmp0_plus_0.plus_28(toLong(tmp1_plus_0));
      tmp = doubleFromBits(tmp3_fromBits_0);
    }
    return tmp;
  }
  function isNaN_0(_this_) {
    return !(_this_ === _this_);
  }
  function isInfinite(_this_) {
    return _this_ === Infinity ? true : _this_ === -Infinity;
  }
  function isFinite(_this_) {
    return !isInfinite(_this_) ? !isNaN_0(_this_) : false;
  }
  var INV_2_26;
  var INV_2_53;
  function doubleFromParts(hi26, low27) {
    return hi26 * INV_2_26 + low27 * INV_2_53;
  }
  function defaultPlatformRandom() {
    var tmp0_unsafeCast_0 = Math.random() * Math.pow(2, 32) | 0;
    return Random_0(tmp0_unsafeCast_0);
  }
  function INV_2_26$init$() {
    var tmp0_pow_0 = 2.0;
    var tmp1_pow_0 = -26;
    return Math.pow(tmp0_pow_0, tmp1_pow_0);
  }
  function INV_2_53$init$() {
    var tmp0_pow_0 = 2.0;
    var tmp1_pow_0 = -53;
    return Math.pow(tmp0_pow_0, tmp1_pow_0);
  }
  function Iterable() {
  }
  Iterable.$metadata$ = {
    simpleName: 'Iterable',
    kind: 'interface',
    interfaces: []
  };
  var buf;
  var bufFloat64;
  var bufInt32;
  var lowIndex;
  var highIndex;
  function doubleFromBits(value) {
    bufInt32[lowIndex] = value._low;
    bufInt32[highIndex] = value._high;
    return bufFloat64[0];
  }
  function doubleToRawBits(value) {
    bufFloat64[0] = value;
    return new Long(bufInt32[lowIndex], bufInt32[highIndex]);
  }
  function bufFloat64$init$() {
    var tmp0_unsafeCast_0 = new Float64Array(buf);
    return tmp0_unsafeCast_0;
  }
  function bufInt32$init$() {
    var tmp0_unsafeCast_0 = new Int32Array(buf);
    return tmp0_unsafeCast_0;
  }
  function lowIndex$init$() {
    bufFloat64[0] = -1.0;
    return !(bufInt32[0] === 0) ? 1 : 0;
  }
  function toString(o) {
    var tmp;
    if (o == null) {
      tmp = 'null';
    } else if (isArrayish(o)) {
      tmp = '[...]';
    } else {
      var tmp0_unsafeCast_0 = o.toString();
      tmp = tmp0_unsafeCast_0;
    }
    return tmp;
  }
  function captureStack(instance, constructorFunction) {
    if (Error.captureStackTrace != null) {
      Error.captureStackTrace(instance, constructorFunction);
    } else {
      instance.stack = (new Error()).stack;
    }
  }
  function extendThrowable(this_, message, cause) {
    Error.call(this_);
    setPropertiesToThrowableInstance(this_, message, cause);
  }
  function setPropertiesToThrowableInstance(this_, message, cause) {
    if (!hasOwnPrototypeProperty(this_, 'message')) {
      var tmp;
      if (message == null) {
        var tmp_0;
        if (!(message === null)) {
          var tmp0_safe_receiver = cause;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
          tmp_0 = tmp1_elvis_lhs == null ? undefined : tmp1_elvis_lhs;
        } else {
          tmp_0 = undefined;
        }
        tmp = tmp_0;
      } else {
        tmp = message;
      }
      this_.message = tmp;
    }if (!hasOwnPrototypeProperty(this_, 'cause')) {
      this_.cause = cause;
    }this_.name = Object.getPrototypeOf(this_).constructor.name;
  }
  function hasOwnPrototypeProperty(o, name) {
    var tmp0_unsafeCast_0 = Object.getPrototypeOf(o).hasOwnProperty(name);
    return tmp0_unsafeCast_0;
  }
  function THROW_CCE() {
    throw ClassCastException_init_$Create$();
  }
  function throwUninitializedPropertyAccessException(name) {
    throw UninitializedPropertyAccessException_init_$Create$('' + 'lateinit property ' + name + ' has not been initialized');
  }
  function Companion_2() {
    Companion_instance_1 = this;
    this._MIN_VALUE_1 = new Long(0, -2147483648);
    this._MAX_VALUE_1 = new Long(-1, 2147483647);
    this._SIZE_BYTES_1 = 8;
    this._SIZE_BITS_1 = 64;
  }
  Companion_2.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_2();
    return Companion_instance_1;
  }
  function Long(low, high) {
    Companion_getInstance_1();
    Number_0.call(this);
    this._low = low;
    this._high = high;
  }
  Long.prototype.plus_28 = function (other) {
    return add(this, other);
  };
  Long.prototype.div_28 = function (other) {
    return divide(this, other);
  };
  Long.prototype.unaryMinus_4 = function () {
    return this.inv_0().plus_28(new Long(1, 0));
  };
  Long.prototype.inv_0 = function () {
    return new Long(~this._low, ~this._high);
  };
  Long.prototype.toInt_4 = function () {
    return this._low;
  };
  Long.prototype.toDouble_4 = function () {
    return toNumber(this);
  };
  Long.prototype.valueOf = function () {
    return this.toDouble_4();
  };
  Long.prototype.toString = function () {
    return toStringImpl(this, 10);
  };
  Long.$metadata$ = {
    simpleName: 'Long',
    kind: 'class',
    interfaces: [Comparable]
  };
  var ZERO;
  var ONE;
  var NEG_ONE;
  var MAX_VALUE;
  var MIN_VALUE;
  var TWO_PWR_24_;
  function compare(_this_, other) {
    if (equalsLong(_this_, other)) {
      return 0;
    }var thisNeg = isNegative(_this_);
    var otherNeg = isNegative(other);
    return (thisNeg ? !otherNeg : false) ? -1 : (!thisNeg ? otherNeg : false) ? 1 : isNegative(subtract(_this_, other)) ? -1 : 1;
  }
  function add(_this_, other) {
    var a48 = _this_._high >>> 16;
    var a32 = _this_._high & 65535;
    var a16 = _this_._low >>> 16;
    var a00 = _this_._low & 65535;
    var b48 = other._high >>> 16;
    var b32 = other._high & 65535;
    var b16 = other._low >>> 16;
    var b00 = other._low & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + (a00 + b00 | 0) | 0;
    c16 = c16 + (c00 >>> 16) | 0;
    c00 = c00 & 65535;
    c16 = c16 + (a16 + b16 | 0) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c32 = c32 + (a32 + b32 | 0) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (a48 + b48 | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function subtract(_this_, other) {
    return add(_this_, other.unaryMinus_4());
  }
  function multiply(_this_, other) {
    if (isZero(_this_)) {
      return ZERO;
    } else if (isZero(other)) {
      return ZERO;
    }if (equalsLong(_this_, MIN_VALUE)) {
      return isOdd(other) ? MIN_VALUE : ZERO;
    } else if (equalsLong(other, MIN_VALUE)) {
      return isOdd(_this_) ? MIN_VALUE : ZERO;
    }if (isNegative(_this_)) {
      var tmp;
      if (isNegative(other)) {
        tmp = multiply(negate(_this_), negate(other));
      } else {
        tmp = negate(multiply(negate(_this_), other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(multiply(_this_, negate(other)));
    }if (lessThan(_this_, TWO_PWR_24_) ? lessThan(other, TWO_PWR_24_) : false) {
      return fromNumber(toNumber(_this_) * toNumber(other));
    }var a48 = _this_._high >>> 16;
    var a32 = _this_._high & 65535;
    var a16 = _this_._low >>> 16;
    var a00 = _this_._low & 65535;
    var b48 = other._high >>> 16;
    var b32 = other._high & 65535;
    var b16 = other._low >>> 16;
    var b00 = other._low & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + imul(a00, b00) | 0;
    c16 = c16 + (c00 >>> 16) | 0;
    c00 = c00 & 65535;
    c16 = c16 + imul(a16, b00) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c16 = c16 + imul(a00, b16) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c32 = c32 + imul(a32, b00) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a16, b16) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a00, b32) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (((imul(a48, b00) + imul(a32, b16) | 0) + imul(a16, b32) | 0) + imul(a00, b48) | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function divide(_this_, other) {
    if (isZero(other)) {
      throw Exception_init_$Create$('division by zero');
    } else if (isZero(_this_)) {
      return ZERO;
    }if (equalsLong(_this_, MIN_VALUE)) {
      if (equalsLong(other, ONE) ? true : equalsLong(other, NEG_ONE)) {
        return MIN_VALUE;
      } else if (equalsLong(other, MIN_VALUE)) {
        return ONE;
      } else {
        var halfThis = shiftRight(_this_, 1);
        var approx = shiftLeft(halfThis.div_28(other), 1);
        if (equalsLong(approx, ZERO)) {
          return isNegative(other) ? ONE : NEG_ONE;
        } else {
          var rem = subtract(_this_, multiply(other, approx));
          return add(approx, rem.div_28(other));
        }
      }
    } else if (equalsLong(other, MIN_VALUE)) {
      return ZERO;
    }if (isNegative(_this_)) {
      var tmp;
      if (isNegative(other)) {
        tmp = negate(_this_).div_28(negate(other));
      } else {
        tmp = negate(negate(_this_).div_28(other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(_this_.div_28(negate(other)));
    }var res = ZERO;
    var rem_0 = _this_;
    while (greaterThanOrEqual(rem_0, other)) {
      var approxDouble = toNumber(rem_0) / toNumber(other);
      var approx2 = Math.max(1.0, Math.floor(approxDouble));
      var log2 = Math.ceil(Math.log(approx2) / Math.LN2);
      var delta = log2 <= 48.0 ? 1.0 : Math.pow(2, log2 - 48);
      var approxRes = fromNumber(approx2);
      var approxRem = multiply(approxRes, other);
      while (isNegative(approxRem) ? true : greaterThan(approxRem, rem_0)) {
        approx2 = approx2 - delta;
        approxRes = fromNumber(approx2);
        approxRem = multiply(approxRes, other);
      }
      if (isZero(approxRes)) {
        approxRes = ONE;
      }res = add(res, approxRes);
      rem_0 = subtract(rem_0, approxRem);
    }
    return res;
  }
  function shiftLeft(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low << numBits_0, _this_._high << numBits_0 | _this_._low >>> (32 - numBits_0 | 0));
      } else {
        return new Long(0, _this_._low << (numBits_0 - 32 | 0));
      }
    }
  }
  function shiftRight(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low >>> numBits_0 | _this_._high << (32 - numBits_0 | 0), _this_._high >> numBits_0);
      } else {
        return new Long(_this_._high >> (numBits_0 - 32 | 0), _this_._high >= 0 ? 0 : -1);
      }
    }
  }
  function toNumber(_this_) {
    return _this_._high * 4.294967296E9 + getLowBitsUnsigned(_this_);
  }
  function equalsLong(_this_, other) {
    return _this_._high === other._high ? _this_._low === other._low : false;
  }
  function toStringImpl(_this_, radix) {
    if (radix < 2 ? true : 36 < radix) {
      throw Exception_init_$Create$('' + 'radix out of range: ' + radix);
    }if (isZero(_this_)) {
      return '0';
    }if (isNegative(_this_)) {
      if (equalsLong(_this_, MIN_VALUE)) {
        var radixLong = fromInt(radix);
        var div = _this_.div_28(radixLong);
        var rem = subtract(multiply(div, radixLong), _this_).toInt_4();
        var tmp = toStringImpl(div, radix);
        var tmp0_unsafeCast_0 = rem.toString(radix);
        return tmp + tmp0_unsafeCast_0;
      } else {
        return '' + '-' + toStringImpl(negate(_this_), radix);
      }
    }var radixToPower = fromNumber(Math.pow(radix, 6.0));
    var rem_0 = _this_;
    var result = '';
    while (true) {
      var remDiv = rem_0.div_28(radixToPower);
      var intval = subtract(rem_0, multiply(remDiv, radixToPower)).toInt_4();
      var tmp1_unsafeCast_0 = intval.toString(radix);
      var digits = tmp1_unsafeCast_0;
      rem_0 = remDiv;
      if (isZero(rem_0)) {
        return digits + result;
      } else {
        while (digits.length < 6) {
          digits = '0' + digits;
        }
        result = digits + result;
      }
    }
  }
  function fromInt(value) {
    return new Long(value, value < 0 ? -1 : 0);
  }
  function isNegative(_this_) {
    return _this_._high < 0;
  }
  function isZero(_this_) {
    return _this_._high === 0 ? _this_._low === 0 : false;
  }
  function isOdd(_this_) {
    return (_this_._low & 1) === 1;
  }
  function negate(_this_) {
    return _this_.unaryMinus_4();
  }
  function lessThan(_this_, other) {
    return compare(_this_, other) < 0;
  }
  function fromNumber(value) {
    if (isNaN_0(value)) {
      return ZERO;
    } else if (value <= -9.223372036854776E18) {
      return MIN_VALUE;
    } else if (value + 1 >= 9.223372036854776E18) {
      return MAX_VALUE;
    } else if (value < 0.0) {
      return negate(fromNumber(-value));
    } else {
      var twoPwr32 = 4.294967296E9;
      return new Long(jsBitwiseOr(value % twoPwr32, 0), jsBitwiseOr(value / twoPwr32, 0));
    }
  }
  function greaterThan(_this_, other) {
    return compare(_this_, other) > 0;
  }
  function greaterThanOrEqual(_this_, other) {
    return compare(_this_, other) >= 0;
  }
  function getLowBitsUnsigned(_this_) {
    return _this_._low >= 0 ? _this_._low : 4.294967296E9 + _this_._low;
  }
  function imul(a_local, b_local) {
    var lhs = jsBitwiseAnd(a_local, 4.29490176E9) * jsBitwiseAnd(b_local, 65535);
    var rhs = jsBitwiseAnd(a_local, 65535) * b_local;
    return jsBitwiseOr(lhs + rhs, 0);
  }
  function numberToInt(a) {
    var tmp;
    if (a instanceof Long) {
      tmp = a.toInt_4();
    } else {
      {
        tmp = doubleToInt(a);
      }
    }
    return tmp;
  }
  function doubleToInt(a) {
    return a > 2.147483647E9 ? 2147483647 : a < -2.147483648E9 ? -2147483648 : jsBitwiseOr(a, 0);
  }
  function toLong(a) {
    return fromInt(a);
  }
  function numberRangeToNumber(start, endInclusive) {
    return new IntRange(start, endInclusive);
  }
  function isArrayish(o) {
    var tmp;
    if (isJsArray(o)) {
      tmp = true;
    } else {
      var tmp0_unsafeCast_0 = ArrayBuffer.isView(o);
      tmp = tmp0_unsafeCast_0;
    }
    return tmp;
  }
  function isJsArray(obj) {
    var tmp0_unsafeCast_0 = Array.isArray(obj);
    return tmp0_unsafeCast_0;
  }
  function Exception_init_$Init$($this) {
    extendThrowable($this, void 1, void 1);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Init$_0(message, $this) {
    extendThrowable($this, message, void 1);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Create$(message) {
    var tmp = Exception_init_$Init$_0(message, Object.create(Exception.prototype));
    captureStack(tmp, Exception_init_$Create$);
    return tmp;
  }
  function Exception() {
    captureStack(this, Exception);
  }
  Exception.$metadata$ = {
    simpleName: 'Exception',
    kind: 'class',
    interfaces: []
  };
  function IllegalArgumentException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalArgumentException.call($this);
    return $this;
  }
  function IllegalArgumentException_init_$Create$(message) {
    var tmp = IllegalArgumentException_init_$Init$(message, Object.create(IllegalArgumentException.prototype));
    captureStack(tmp, IllegalArgumentException_init_$Create$);
    return tmp;
  }
  function IllegalArgumentException() {
    captureStack(this, IllegalArgumentException);
  }
  IllegalArgumentException.$metadata$ = {
    simpleName: 'IllegalArgumentException',
    kind: 'class',
    interfaces: []
  };
  function RuntimeException_init_$Init$($this) {
    Exception_init_$Init$($this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Init$_0(message, $this) {
    Exception_init_$Init$_0(message, $this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException() {
    captureStack(this, RuntimeException);
  }
  RuntimeException.$metadata$ = {
    simpleName: 'RuntimeException',
    kind: 'class',
    interfaces: []
  };
  function ClassCastException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    ClassCastException.call($this);
    return $this;
  }
  function ClassCastException_init_$Create$() {
    var tmp = ClassCastException_init_$Init$(Object.create(ClassCastException.prototype));
    captureStack(tmp, ClassCastException_init_$Create$);
    return tmp;
  }
  function ClassCastException() {
    captureStack(this, ClassCastException);
  }
  ClassCastException.$metadata$ = {
    simpleName: 'ClassCastException',
    kind: 'class',
    interfaces: []
  };
  function UninitializedPropertyAccessException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UninitializedPropertyAccessException.call($this);
    return $this;
  }
  function UninitializedPropertyAccessException_init_$Create$(message) {
    var tmp = UninitializedPropertyAccessException_init_$Init$(message, Object.create(UninitializedPropertyAccessException.prototype));
    captureStack(tmp, UninitializedPropertyAccessException_init_$Create$);
    return tmp;
  }
  function UninitializedPropertyAccessException() {
    captureStack(this, UninitializedPropertyAccessException);
  }
  UninitializedPropertyAccessException.$metadata$ = {
    simpleName: 'UninitializedPropertyAccessException',
    kind: 'class',
    interfaces: []
  };
  function jsBitwiseOr(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = lhs_hack | rhs_hack;
    return tmp0_unsafeCast_0;
  }
  function jsBitwiseAnd(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = lhs_hack & rhs_hack;
    return tmp0_unsafeCast_0;
  }
  function toRawBits(_this_) {
    return doubleToRawBits(_this_);
  }
  function SerializableWith() {
  }
  SerializableWith.$metadata$ = {
    simpleName: 'SerializableWith',
    kind: 'class',
    interfaces: [Annotation],
    associatedObjectKey: 0
  };
  var MACHINE_EPSILON;
  function LinearType() {
  }
  LinearType.$metadata$ = {
    simpleName: 'LinearType',
    kind: 'interface',
    interfaces: []
  };
  function Companion_3() {
    Companion_instance_2 = this;
  }
  Companion_3.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_3();
    return Companion_instance_2;
  }
  function Polar(theta, radius) {
    Companion_getInstance_2();
    this._theta = theta;
    this._radius = radius;
  }
  Polar.prototype._get_cartesian_ = function () {
    return Companion_getInstance_3().fromPolar(this);
  };
  Polar.prototype.toString = function () {
    return '' + 'Polar(theta=' + this._theta + ', radius=' + this._radius + ')';
  };
  Polar.$metadata$ = {
    simpleName: 'Polar',
    kind: 'class',
    interfaces: [LinearType]
  };
  function Companion_4() {
    Companion_instance_3 = this;
    this._ZERO = new Vector2(0.0, 0.0);
    this._ONE = new Vector2(1.0, 1.0);
    this._UNIT_X = new Vector2(1.0, 0.0);
    this._UNIT_Y = new Vector2(0.0, 1.0);
    this._INFINITY = new Vector2(Infinity, Infinity);
  }
  Companion_4.prototype.fromPolar = function (polar) {
    var tmp0__get_asRadians__0 = polar._theta;
    var theta = tmp0__get_asRadians__0 * 0.017453292519943295;
    var x = Math.cos(theta);
    var y = Math.sin(theta);
    return (new Vector2(x, y)).times_30(polar._radius);
  };
  Companion_4.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_3;
  function Companion_getInstance_3() {
    if (Companion_instance_3 == null)
      new Companion_4();
    return Companion_instance_3;
  }
  function Vector2(x, y) {
    Companion_getInstance_3();
    this._x_0 = x;
    this._y_0 = y;
  }
  Vector2.prototype.plus_0 = function (vector2) {
    return new Vector2(this._x_0 + vector2._x_0, this._y_0 + vector2._y_0);
  };
  Vector2.prototype.times_30 = function (d) {
    return new Vector2(this._x_0 * d, this._y_0 * d);
  };
  Vector2.prototype.times_0 = function (v) {
    return new Vector2(this._x_0 * v._x_0, this._y_0 * v._y_0);
  };
  Vector2.prototype.div_30 = function (d) {
    return new Vector2(this._x_0 / d, this._y_0 / d);
  };
  Vector2.prototype.toString = function () {
    return '' + 'Vector2(x=' + this._x_0 + ', y=' + this._y_0 + ')';
  };
  Vector2.$metadata$ = {
    simpleName: 'Vector2',
    kind: 'class',
    interfaces: [LinearType]
  };
  var FLIP_Y;
  function _get_resolution_() {
    return new Vector2(_get_width_(), _get_height_());
  }
  function _get_minDimension_() {
    var tmp0_min_0 = _get_width_();
    var tmp1_min_0 = _get_height_();
    return function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Float64Array([tmp0_min_0, tmp1_min_0]))));
    }.call(this);
  }
  function toScreenCoord(coord) {
    return coord.times_0(FLIP_Y).times_30(_get_minDimension_()).plus_0(_get_resolution_()).div_30(2.0);
  }
  function moveTo(_this_, coord) {
    return _this_.moveTo(coord._x_0, coord._y_0);
  }
  function lineTo(_this_, coord) {
    return _this_.lineTo(coord._x_0, coord._y_0);
  }
  function clearScreen(_this_, fillStyle) {
    _this_.fillStyle = fillStyle;
    _this_.fillRect(0.0, 0.0, _get_width_(), _get_height_());
  }
  function main() {
    var tmp = window;
    tmp.onload = _no_name_provided_$factory();
  }
  function _get_painter_() {
    var tmp = painter;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('painter');
    }
  }
  var painter;
  function _get_canvas_() {
    return _get_painter_()._canvas2d;
  }
  function _get_time_() {
    return _get_painter_()._time;
  }
  function _get_width_() {
    return _get_painter_()._width;
  }
  function _get_height_() {
    return _get_painter_()._height;
  }
  function Painter_init_$Init$(backgroundFillStyle, drawFunction, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      backgroundFillStyle = 'black';
    Painter.call($this, backgroundFillStyle, drawFunction);
    return $this;
  }
  function Painter_init_$Create$(backgroundFillStyle, drawFunction, $mask0, $marker) {
    return Painter_init_$Init$(backgroundFillStyle, drawFunction, $mask0, $marker, Object.create(Painter.prototype));
  }
  function render($this) {
    var tmp = window;
    tmp.requestAnimationFrame(_no_name_provided_$factory_1($this));
    Unit_getInstance();
    if (maybeResize($this)) {
      resize($this);
    }$this._time = window.performance.now() / 1000;
    $this._drawFunction();
  }
  function maybeResize($this) {
    return !($this._cssWidth === $this._canvas.clientWidth) ? true : !($this._cssHeight === $this._canvas.clientHeight);
  }
  function resize($this) {
    var pixelRatio = window.devicePixelRatio;
    $this._cssWidth = $this._canvas.clientWidth;
    $this._cssHeight = $this._canvas.clientHeight;
    var tmp = $this;
    var tmp0_floor_0 = $this._cssWidth * pixelRatio;
    var tmp0_unsafeCast_0_1 = Math.floor(tmp0_floor_0);
    tmp._width = numberToInt(tmp0_unsafeCast_0_1);
    var tmp_0 = $this;
    var tmp1_floor_0 = $this._cssHeight * pixelRatio;
    var tmp0_unsafeCast_0_1_0 = Math.floor(tmp1_floor_0);
    tmp_0._height = numberToInt(tmp0_unsafeCast_0_1_0);
    $this._canvas.width = $this._width;
    $this._canvas.height = $this._height;
  }
  function _no_name_provided_(this$0) {
    this._this$0 = this$0;
  }
  _no_name_provided_.prototype.invoke_0 = function (it) {
    render(this._this$0);
  };
  _no_name_provided_.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__0(this$0) {
    this._this$0_0 = this$0;
  }
  _no_name_provided__0.prototype.invoke_0 = function (it) {
    render(this._this$0_0);
  };
  _no_name_provided__0.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Painter(backgroundFillStyle, drawFunction) {
    this._backgroundFillStyle = backgroundFillStyle;
    this._drawFunction = drawFunction;
    var tmp = this;
    var tmp0_safe_receiver = document.body;
    var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.appendChild(document.createElement('canvas'));
    tmp._canvas = tmp_0 instanceof HTMLCanvasElement ? tmp_0 : THROW_CCE();
    var tmp_1 = this;
    var tmp_2 = function () {
      var $externalVarargReceiverTmp = this._canvas;
      return $externalVarargReceiverTmp.getContext.apply($externalVarargReceiverTmp, ['2d']);
    }.call(this);
    tmp_1._canvas2d = tmp_2 instanceof CanvasRenderingContext2D ? tmp_2 : THROW_CCE();
    var tmp0_with_0 = this._canvas.style;
    tmp0_with_0.position = 'fixed';
    tmp0_with_0.width = '100vw';
    tmp0_with_0.height = '100vh';
    tmp0_with_0.top = '0';
    tmp0_with_0.left = '0';
    tmp0_with_0.zIndex = '-10';
    var tmp_3 = window;
    tmp_3.requestAnimationFrame(_no_name_provided_$factory_0(this));
    Unit_getInstance();
    this._time = 0.0;
    this._width = 0;
    this._height = 0;
    this._cssWidth = 0;
    this._cssHeight = 0;
  }
  Painter.$metadata$ = {
    simpleName: 'Painter',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1() {
  }
  _no_name_provided__1.prototype.invoke_1 = function () {
    draw();
  };
  _no_name_provided__1.prototype.invoke_2 = function () {
    this.invoke_1();
    return Unit_getInstance();
  };
  _no_name_provided__1.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__2() {
  }
  _no_name_provided__2.prototype.invoke_3 = function (it) {
    painter = Painter_init_$Create$(null, _no_name_provided_$factory_2(), 1, null);
    return true;
  };
  _no_name_provided__2.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory() {
    var i = new _no_name_provided__2();
    return function (p1) {
      return i.invoke_3(p1);
    };
  }
  function _no_name_provided_$factory_0(this$0) {
    var i = new _no_name_provided_(this$0);
    return function (p1) {
      i.invoke_0(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_1(this$0) {
    var i = new _no_name_provided__0(this$0);
    return function (p1) {
      i.invoke_0(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_2() {
    var i = new _no_name_provided__1();
    return function () {
      i.invoke_1();
      return Unit_getInstance();
    };
  }
  var startPoint;
  var branchCountRange;
  function _get_growth_() {
    var tmp0_sin_0 = _get_time_() * 0.1;
    return (Math.sin(tmp0_sin_0) + 1.0) / 4.0;
  }
  function _get_windTwist_() {
    var tmp0_sin_0 = _get_time_() * 0.5;
    return Math.sin(tmp0_sin_0) * 7.0;
  }
  function draw() {
    clearScreen(_get_canvas_(), 'black');
    var random = Random_0(0);
    tree(startPoint, 90.0 + _get_windTwist_(), _get_windTwist_(), _get_growth_(), 0.03, 60.0, 0, Random_0(0));
  }
  function tree(start, angle, windTwist, growth, branchingThreshold, branchAngleVariation, generation, random) {
    var end = start.plus_0((new Polar(angle, growth))._get_cartesian_());
    drawBranch(start, end, growth * 20.0);
    if (growth > branchingThreshold) {
      var branchCount = nextInt(random, branchCountRange);
      var tmp0_forEach_0 = until(0, branchCount);
      var inductionVariable = tmp0_forEach_0._get_first__0();
      var last = tmp0_forEach_0._get_last__0();
      if (inductionVariable <= last)
        do {
          var element_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          tree(end, random.nextDouble_4(angle - branchAngleVariation, angle + branchAngleVariation) + windTwist, windTwist, (growth - branchingThreshold) * random.nextDouble_4(0.6, 0.9), branchingThreshold, branchAngleVariation, generation + 1 | 0, Random_0(imul(generation, 10) + element_2 | 0));
        }
         while (!(element_2 === last));
    }}
  function drawBranch(start, end, width) {
    var tmp0_with_0 = _get_canvas_();
    tmp0_with_0.beginPath();
    moveTo(tmp0_with_0, toScreenCoord(start));
    tmp0_with_0.lineWidth = width;
    tmp0_with_0.strokeStyle = 'white';
    lineTo(tmp0_with_0, toScreenCoord(end));
    tmp0_with_0.stroke();
    tmp0_with_0.closePath();
  }
  INV_2_26 = INV_2_26$init$();
  INV_2_53 = INV_2_53$init$();
  buf = new ArrayBuffer(8);
  bufFloat64 = bufFloat64$init$();
  bufInt32 = bufInt32$init$();
  lowIndex = lowIndex$init$();
  highIndex = 1 - lowIndex | 0;
  ZERO = fromInt(0);
  ONE = fromInt(1);
  NEG_ONE = fromInt(-1);
  MAX_VALUE = new Long(-1, 2147483647);
  MIN_VALUE = new Long(0, -2147483648);
  TWO_PWR_24_ = fromInt(16777216);
  MACHINE_EPSILON = _get_ulp_(1.0);
  FLIP_Y = new Vector2(1.0, -1.0);
  startPoint = new Vector2(0.0, -1.0);
  branchCountRange = numberRangeToNumber(1, 8);
  main();
  return _;
}));
